// Module
var code = "<div class=\"alert-selector-message\">\r\n    <terceraLabel visible=\"{{visible}}\" text=\"{{label}}\" />\r\n    <textarea id=\"alert-message\" class=\"alertMessage {{#if !isMessageTextValid}}alert-message-border{{/if}}\" maxlength=\"100\" placeholder=\"{{.placeholder}}\">{{.messageText}}</textarea>\r\n</div>";
// Exports
export default code;